import { useNavigate } from 'react-router-dom';
import CustomModal from '../../../../../../components/modal/CustomModal';
import { InlineWidget } from 'react-calendly';
import CustomButton from '../../../../../../components/button/CustomButton';
import { Divider, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CalendlyModal = ({
  open,
  showActionBtn,
  caseStudyId,
  handleCancel,
}: {
  open: boolean;
  showActionBtn: boolean;
  caseStudyId: string;
  handleCancel: () => void;
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const url = `${process.env.REACT_APP_CALENDLY_URL as string}?locale=${i18n.language}`;
  return (
    <CustomModal
      width={{ xs: '80%', sm: '70%', lg: '50%' } as Record<string, string>}
      paperStyleProps={{ p: { xs: '2rem', lg: '2rem' } }}
      open={open}
    >
      <Stack spacing={2}>
        <InlineWidget url={url} />
        <Divider />
        <Stack direction="row" sx={{ justifyContent: 'right' }} spacing={4}>
          {showActionBtn ? (
            <CustomButton
              sx={{ mt: 2 }}
              onClick={() => navigate(`../case-study/${caseStudyId}/submit-review`)}
            >
              {t('common.continue')}
            </CustomButton>
          ) : (
            <CustomButton variant="primaryLight" sx={{ mt: 2 }} onClick={handleCancel}>
              {t('common.cancel')}
            </CustomButton>
          )}
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default CalendlyModal;
